<template>
  <div>
    <b-form class="form user-settings">
      <!--b-row -->
        <!--b-col cols="6"-->
          <h3>Add/View Photos</h3>
          <b-form-group
              label="Create A Memory"
              description="Create memories by adding and editing your photo"
          >
            <b-row>
              <b-col cols="1">
                <b-icon
                    icon="image"
                    animation="fade"
                    font-scale="2"
                />
              </b-col>
              <b-col cols="10">
                <item-add-image
                    style="margin-left: 5px;"
                    :modal-id="modalImageAddId"
                    modal-title="Create a Memory"
                    btn-title="Done"
                    name="title"
                    :can-search="false"
                    @selected-items="handleImageItems"
                />
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group
              :description="
              `Click menu to see your current ${userDataPhotos.length} photos`
            "
          >
            <items-sidebar-settings
                :items="userDataPhotos"
                :assets-url-home="assetsURLHome"
            />
          </b-form-group>
        <!--/b-col-->
        <!--b-col cols="6"-->
          <b-form-group>
            <drop-down-field
                field-name="Transition Style:"
                field-key="transition_style"
                :options-json="optionsJSON"
                :selected-value="settingsUser.transitionStyle"
                select-word="Style"
                @selected-option="handleOptionsSelect"
            />
          </b-form-group>
          <b-form-group>
            <drop-down-field
                field-name="Display Your Photos Your Way:"
                field-key="photo_display"
                :options-json="optionsJSON"
                :selected-value="settingsUser.photoDisplay"
                select-word="Display"
                @selected-option="handleOptionsSelect"
            />
          </b-form-group>
          <b-form-group
              label="Interval (sec):"
              description="How long photo shall wait before transitioning?"
          >
            <b-form-spinbutton
                id="match-size"
                v-model="settingsUser.interval"
                :min="intervalMin"
                :max="intervalMax"
                @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group
              label="Background PlayList:"
              description="Choose the songs you would like to play in the background."
          >
            <b-row>
              <b-col cols="1">
                <b-img
                    v-bind="iconImgProps"
                    rounded alt="Rounded image"
                />
              </b-col>
              <b-col cols="1">
                <item-store
                    :modal-id="modalSongStoreId"
                    store-title="Provided by PlayList"
                    btn-download-title="Add A Background song"
                    name="title"
                    asset-url-path="/assets/apps/playlist/"
                    :store-items="_pubStoreAudioItemsPlayList"
                    :user-owned-items="[]"
                    @selected-items="handleSelectedAudios"
                />
              </b-col>
               <b-col cols="10">
                <b-img
                    v-bind="mainPropAlbumCover"
                    v-for="(aSong, s) in settingsUser.bgSongs"
                    :src="`${assetsPathFromPlayList}${aSong.imgURL}`"
                    rounded
                    :alt="`${aSong.title} image`"
                    :key="`song_${s}`"
                    style="margin-right: 5px"
                />
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group>
            <toggles-form
              :data-array="toggles"
              @toggles-change="handleToggleChange"
            />
          </b-form-group>
        <!-- /b-col -->
      <!-- /b-row -->
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DropDownField from "@/components/blockResources/_components/dropDownField";
import ResourceBlockSettings from "@/mixins/resourceBlocks/Settings";
import optionsJSON from "../../assets/json/optionsJSON.json";
import ItemStore from "@/components/blockResources/_components/itemStore";
import ItemAddImage from "@/components/blockResources/_components/itemAddImage";
import ItemsSidebarSettings from "@/components/blockResources/_components/itemsSideBar";
import DefaultPhotos from "../../assets/json/defaultPhotoAlbum.json";
import _pubStoreAudioItemsPlayListJSON from "@/assets/_appPublic/playList/assets/json/storeItemsSongs.json"
export default {
  name: "Settings_PhotoAlbum",
  components: {
    DropDownField,
    ItemStore,
    ItemAddImage,
    ItemsSidebarSettings
  },
  mixins: [ResourceBlockSettings],
  computed: {
    ...mapGetters({
      apps: "user/apps",
      userData: "user/appsData"
    }),
    iconImgProps() {
      if (this.iconURLFromPlayList) {
        this.mainProps.src = this.iconURLFromPlayList;
      }
      return this.mainProps;
    },
    /* DATA */
    userDataPhotos() {
      return this.userData &&
        this.userData &&
        this.userData[`app_${this.resource.toolId}`] &&
        this.userData[`app_${this.resource.toolId}`].photos
        ? this.userData[`app_${this.resource.toolId}`].photos
        : DefaultPhotos;
    },
    _pubStoreAudioItemsPlayList() {
      return  _pubStoreAudioItemsPlayListJSON && _pubStoreAudioItemsPlayListJSON.public &&
          Array.isArray(_pubStoreAudioItemsPlayListJSON.public) &&
          _pubStoreAudioItemsPlayListJSON.public[0].data &&
          Array.isArray(_pubStoreAudioItemsPlayListJSON.public[0].data) ?
          _pubStoreAudioItemsPlayListJSON.public[0].data :[];
    },
    assetsPathFromPlayList() {
      return  _pubStoreAudioItemsPlayListJSON && _pubStoreAudioItemsPlayListJSON.pathAssets?
          _pubStoreAudioItemsPlayListJSON && _pubStoreAudioItemsPlayListJSON.pathAssets:"";
    },
    iconURLFromPlayList() {
      return  _pubStoreAudioItemsPlayListJSON && _pubStoreAudioItemsPlayListJSON.urlIconImg?
          _pubStoreAudioItemsPlayListJSON && _pubStoreAudioItemsPlayListJSON.urlIconImg:"";
    },
  },
  methods: {
    handleImageItems(photos) {
      console.log(`These photos selected:${photos}`);
      let photoItems = {
        photos: photos
      };

      let notif = {//create message
        title: `${photos.length} Memories Added`,
        description: "Congrats you have updated your family memories",
        variant: "success"
      };
      const payload = {
        userData: photoItems,
        notif: notif,
        key: "photos"
      };
      this.handleUpdateUserData(payload);
    },
    handleShowPlayListClick() {
      //inside of sidebar?
      this.sidebarModel = false;
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    },
    handleSelectedAudios(selectedAudios){
      this.settingsUser.bgSongs = selectedAudios;
    },
    handleOptionsSelect({key, option}){
      switch (key){
        case 'transition_style':
          this.settingsUser.transitionStyle = option.value ? option.value : null;
          break;
        case 'photo_display':
          this.settingsUser.photoDisplay = option.value ? option.value : null;
          break;
          default:
            //applog bug
              break;
      }
      this.handleSettingsUserChange();
    }
  },
  data() {
    return {
      optionsJSON,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 30,
        height: 30,
        class: "m1"
      },
      mainPropAlbumCover: {
        blank: false,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      },
      modalSongStoreId:"playlist-store-id",
      settingsUser: {
        bgSongs: this.settings && this.settings.user && this.settings.user.bgSongs
            ? this.settings.user.bgSongs
            : [],
        interval:
          this.settings && this.settings.user && this.settings.user.interval
            ? this.settings.user.interval
            : 1,
        transitionStyle:
          this.settings && this.settings.user && this.settings.user.transitionStyle
            ? this.settings.user.transitionStyle
            : "fade",
        photoDisplay:
            this.settings && this.settings.user && this.settings.user.photoDisplay
                ? this.settings.user.photoDisplay
                : "full",
        _isRepeat:
          this.settings &&
          this.settings.user &&
          this.settings.user._isRepeat !== undefined
            ? this.settings.user._isRepeat
            : true,
        _isShuffle:
          this.settings &&
          this.settings.user &&
          this.settings.user._isShuffle !== undefined
            ? this.settings.user._isShuffle
            : false,
        _hideBottomBar:
            this.settings &&
            this.settings.user &&
            this.settings.user._hideBottomBar !== undefined
                ? this.settings.user._hideBottomBar
                : false,
        _autoPlayPhotoAudio:
            this.settings &&
            this.settings.user &&
            this.settings.user._autoPlayPhotoAudio !== undefined
                ? this.settings.user._autoPlayPhotoAudio
                : true,
        _autoPlayCreatedByAudio:
            this.settings &&
            this.settings.user &&
            this.settings.user._autoPlayCreatedByAudio !== undefined
                ? this.settings.user._autoPlayCreatedByAudio
                : true,
        _addedBy:
            this.settings &&
            this.settings.user &&
            this.settings.user._addedBy !== undefined
                ? this.settings.user._addedBy
                : true,

      },
      assetsURLHome: "",
      _pubStoreAudioItemsPlayListJSON,
      sidebarId: "settings-sidebar",
      sidebarModel: false,
      modalImageAddId: "photoadd",
      intervalMin: 2,
      intervalMax: 100,
      toggles: [
        {
          name: "Hide the bottom menu bar",
          description:
            "Hide the bottom bar for more presentation space.",
          property: "_hideBottomBar",
          type: "btns",
          text: "Hide the bottom bar for more presentation space.",
          isAvail: true,
          value: false
        },
        {
          name: "PlayPhotoAudio",
          description:
            "Automatically plays the audio recorded for photo on transition",
          property: "_autoPlayPhotoAudio",
          type: "btns",
          text: "Auto-play photo audio",
          isAvail: true,
          value: true
        },
        {name: "PlayFamilyAudio",
          description:
              "Auto-plays the audio for the family member who added the photo",
          property: "_autoPlayCreatedByAudio",
          type: "btns",
          text: "Auto-play family audio",
          isAvail: true,
          value: true
        },
        {
          name: "Repeat",
          description: "Keep the memories playing endlessly.",
          property: "_isRepeat",
          type: "btns",
          text: "Keep the memories playing endlessly.",
          isAvail: true,
          value: false
        },
        {
          name: "Shuffle",
          description: "Mix up your photos",
          property: "_isShuffle",
          type: "btns",
          text: "Enable shuffle mode to mix up your photos",
          isAvail: true,
          value: true
        },
        {
          name: "Added by Family",
          description: "Enable to display the family who added the photo",
          property: "_addedBy",
          type: "btns",
          text: "Show added by family",
          isAvail: true,
          value: true
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
